import React from "react";

const Message = ({ desc, type = "success" }) => {
  return (
    <div
      style={{
        background: type === "success" ? "rgb(69, 170, 67)" : "#fff5e0",
      }}
    >
      <p
        style={{
          color: "#000",
          fontSize: "14px",
          fontWeight: 400,
          padding: "5px 2px",
        }}
      >
        {desc}
      </p>
    </div>
  );
};

export default Message;
